import { sequenceTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useInputState } from '../../hook.use-input-state.js';
import { Tile } from '../atom.tile/_tile-input.js';
import { jsx } from 'react/jsx-runtime';

function SequenceInput(props) {
  const inputEntry = useOpgavekompleksetEntry({
    select: entry => sequenceTileInput.entry.asType(entry?.data.tasks[props.taskEntryKey]?.details[props.node.id])
  });
  const defaultState = useInputState(props.node, inputEntry);
  const state = props.node.options.fixed ? "fixed" : props.facitType === "should-have" && defaultState === "incorrect" ? "should-have" : defaultState;
  return /*#__PURE__*/jsx(Tile, {
    className: props.className,
    tile: props.node,
    state: state,
    isDraggable: !!props.isDraggable,
    isDragOverlay: !!props.isDragOverlay
  });
}

export { SequenceInput };
//# sourceMappingURL=input.content.js.map
